import { createApiActions } from '@tabeeb/shared/utils/actions'

import { Tenant, TenantConfig } from '../types'

// @deprecated - use useTenantConfig hook instead
export const updateConfig = createApiActions<{ subdomain: string; config: TenantConfig }, TenantConfig>('UPDATE_CONFIG')

export const getTenantsList = createApiActions<string, { currentTenant: Tenant; allTenants: Tenant[] }>(
  'GET_TENANTS_LIST'
)
